import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Draggable from 'react-draggable';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import PartService from "../../Controller/PartController";
import { formatDateWithFns } from '../../../Common/DateInputFormat';
import useDateFormat from '../../../Common/fetchDateFormat';
function CreateCustomerSite({ StockSerialID, onClose }) {

    const { t } = useTranslation();

    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);
    const [isMinimized, setIsMinimized] = useState(false);
    const [stockSerialistory, setStockSerialistory] = useState([]);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const activeDateFormat = useDateFormat();
    const fetchStockHistory = async (StockSerialID) => {
        try {
            const stockSerialHistory = await PartService.GetStockSerialHistory(StockSerialID);
            setStockSerialistory(stockSerialHistory);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };


    useEffect(() => {
        fetchStockHistory(StockSerialID);
    }, [StockSerialID]);

    const toggleMinimize = () => {
        setIsMinimized(!isMinimized);
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }

    return (
        <div>

            <div className="modal fade stockSerialModal show d-block" id="stockSerialModal" tabIndex="-1" aria-labelledby="stockSerialModalLabel" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-lg">
                    <Draggable handle=".modal-content" onStart={handleStart}
                        cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">

                        <div className="modal-content" style={{ height: '100%', width: '100%' }}>
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">Serial Tracking History</h5>


                                <span>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <button type="button" className="close" onClick={toggleMinimize} aria-label="Minimize" >
                                        <span aria-hidden="true">{isMinimized ? '+' : '-'}</span>
                                    </button>

                                </span>


                            </div>
                            {!isMinimized && (
                                <div className="modal-body">

                                    <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                        <table className="table m-0 table-hover table-bordered table-striped" style={{ "width": "100%" }}>
                                            <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                                                <tr>
                                                    <th className="no-wrap">Action</th>
                                                    <th className="no-wrap">Action Date</th>
                                                    <th className="no-wrap">Action Taken By</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {stockSerialistory.map((stock, index) => {

                                                    const date = new Date(stock.dt_Added);
                                                    const formattedTime = date.toLocaleTimeString('en-US', {
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                        hour12: false, // Use 24-hour format
                                                    });
                                                    return (
                                                        <tr key={stock.PK_StockSerial_ID} >
                                                            <td className="no-wrap" dangerouslySetInnerHTML={{ __html: stock.vc_Reason }}></td>

                                                            <td className="no-wrap">
                                                                
                                                                {formatDateWithFns(stock.dt_Added, activeDateFormat)}   {formattedTime}
                                                            </td>
                                                            <td className="no-wrap">{stock.DisplayName}</td>

                                                        </tr>
                                                    );
                                                })}
                                            </tbody>



                                        </table>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" onClick={onClose} className="btn btn-secondary">Close</button>
                                    </div>

                                </div>
                            )}
                        </div>

                    </Draggable>
                </div>
            </div>


        </div>
    );
}

export default CreateCustomerSite;
